import { useState, useEffect } from "react";
import {
  getContactosInstaladoresEntregables,
  createAsignacion,
  fetchFasesTrabajo,
} from "../../components/functions/Projects";
import Checkbox from "@mui/material/Checkbox";
import {
  Dialog,
  IconButton,
  Box,
  Typography,
  FormGroup,
  FormControlLabel,
  DialogActions,
  DialogContent,
  Snackbar,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  MaterialReactTable,
  useMaterialReactTable,
  getMRT_RowSelectionHandler,
} from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import CustomButton from "../../ui/button/Button";
import { fetchInstallers } from "../../components/functions/Functions";
import SelectAutoComplete from "../../ui/selectAutoComplete/SelectAutoComplete";
import Map from "../../ui/map/Map";
import PointerMap from "../../assets/img/svg/providers/markerProveedorActivo.svg";
import PointerMapDisable from "../../assets/img/svg/providers/markerProveedorInactivo.svg";
import PointerMapProcess from "../../assets/img/svg/providers/markerProveedorEnProceso.svg";
import PointerInstaladorActivo from "../../assets/img/svg/providers/markerGreen.svg";
import PointerInstaladorInactivo from "../../assets/img/svg/providers/MarkerRed.svg";
import PointerInstaladorEnProceso from "../../assets/img/svg/providers/markerOrange.svg";
import LoaderDialog from "../../ui/loader/Loader";
import RazonModal from "./RazonModal";

const normalize = (str = "") =>
  str
    .toString()
    .toLowerCase()
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .trim();

const canonizarEstatus = (estatus) => {
  const s = normalize(estatus || "inactivo");
  if (["periodo de prueba", "no deseado"].includes(s)) return "inactivo";
  if (s.includes("proceso")) return "proceso de integración";
  if (s.includes("inactivo")) return "inactivo";
  if (s.includes("activo")) return "activo";
  return "inactivo";
};

const getIconUrlByCanonical = (canon) => {
  switch (canon) {
    case "activo":
      return PointerMap;
    case "proceso de integración":
      return PointerMapProcess;
    default:
      return PointerMapDisable;
  }
};

const getInstaladorIcon = (icon) => {
  if (icon.includes("instalador_inactivo.png"))
    return PointerInstaladorInactivo;
  if (icon.includes("instalador_activo.png")) return PointerInstaladorActivo;
  return PointerInstaladorEnProceso;
};

const ModalNuevaAsignacion = ({
  showModal,
  handleCloseModal,
  trabajo,
  companies,
  API_URL,
  onConfirm,
  etapa,
}) => {
  const [showLoader, setShowLoader] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const [empresaSeleccionada, setEmpresaSeleccionada] = useState(null);
  const [instaladores, setInstaladores] = useState([]);
  const [selectedInstalador, setSelectedInstalador] = useState(null);

  const [selected, setSelected] = useState([]); // fase de trabajo
  const isSelected = (name) => selected.some((o) => o.name === name);

  const [markers, setMarkers] = useState([]);
  const [empresaMarker, setEmpresaMarker] = useState();
  const [distance, setDistance] = useState(0);
  const [razon, setRazon] = useState("");

  const [openRazonModal, setOpenRazonModal] = useState(false);

  const [fasesDeTrabajo, setFasesDeTrabajo] = useState([]);

  const byName = {
    LEVANTAMIENTO: fasesDeTrabajo[0],
    ENTREGABLE: fasesDeTrabajo[1],
    MANTENIMIENTO: fasesDeTrabajo[2],
  };

  useEffect(() => {
    if (etapa && showModal) {
      const etapaObj = fasesDeTrabajo.find((f) => f.name === etapa);
      if (etapaObj) {
        setSelected([etapaObj]);
      }
    }

    const fetchFasesDeTrabajo = async () => {
      try {
        const fasesRes = await fetchFasesTrabajo(
          API_URL,
          trabajo?.tipoTrabajo?.id
        );
        setFasesDeTrabajo(fasesRes);
      } catch (error) {
        console.error("Error al obtener las fases de trabajo:", error);
      }
    };

    if (showModal) {
      fetchFasesDeTrabajo();
    }
  }, [etapa, showModal]);

  const handleToggle = (option) => {
    const already = isSelected(option.name);

    if (already) {
      setSelected((prev) => prev.filter((o) => o.name !== option.name));
      return;
    }

    if (option.name === "MANTENIMIENTO") {
      setSelected([byName.MANTENIMIENTO]);
      return;
    }

    const otherName =
      option.name === "LEVANTAMIENTO" ? "ENTREGABLE" : "LEVANTAMIENTO";

    setSelected((prev) => {
      const hasMaintenance = prev.some((o) => o.name === "MANTENIMIENTO");
      if (hasMaintenance) {
        return [option];
      }

      const hasOther = prev.some((o) => o.name === otherName);
      if (hasOther) {
        return [byName.LEVANTAMIENTO, byName.ENTREGABLE];
      }

      return [option];
    });
  };

  const getDistance = (origin, destination) => {
    if (!window.google) return;
    const svc = new window.google.maps.DirectionsService();

    svc.route(
      {
        origin,
        destination,
        travelMode: window.google.maps.TravelMode.DRIVING,
      },
      (res, status) => {
        if (status === window.google.maps.DirectionsStatus.OK) {
          setDistance(res.routes[0].legs[0].distance.value / 1000);
        }
      }
    );
  };

  useEffect(() => {
    const fetchContactosInstaladoresEntregables = async () => {
      const id = Number(Object.keys(selectedInstalador)[0]);
      try {
        const contacto = await getContactosInstaladoresEntregables(API_URL, id);
        if (contacto?.latitude && contacto?.longitude) {
          const marker = {
            lat: contacto?.latitude,
            lng: contacto?.longitude,
            icon: getInstaladorIcon(contacto?.icon),
          };
          setMarkers([empresaMarker, marker]);

          if (trabajo?.latitude && trabajo?.longitude) {
            getDistance(
              {
                lat: trabajo?.latitude,
                lng: trabajo?.longitude,
              },
              {
                lat: contacto?.latitude,
                lng: contacto?.longitude,
              }
            );
          }
        } else {
          setMarkers([empresaMarker]);
        }
      } catch (error) {
        console.error(
          "Error al obtener los contactos de instaladores entregables:",
          error
        );
      }
    };
    if (selectedInstalador && Object.keys(selectedInstalador).length > 0) {
      fetchContactosInstaladoresEntregables();
    } else {
      setMarkers([empresaMarker]);
    }
  }, [selectedInstalador]);

  useEffect(() => {
    setSelectedInstalador(null);
    const fetchInstaladores = async () => {
      try {
        const instaladores = await fetchInstallers(
          API_URL,
          empresaSeleccionada.id
        );
        instaladores.forEach((instalador) => {
          instalador.label = `${instalador.numGafete} - ${instalador.nombre} ${instalador.apellidos}`;
        });
        setInstaladores(instaladores);

        const estatusCanon = canonizarEstatus(
          empresaSeleccionada?.estatusEmpresa?.nombre
        );

        const marker = {
          lat: empresaSeleccionada.latitude,
          lng: empresaSeleccionada.longitude,
          icon: getIconUrlByCanonical(estatusCanon),
          info: {
            razonSocial: empresaSeleccionada?.razonSocial || "Sin razón social",
            direccion: empresaSeleccionada?.direccionFiscal || "Sin dirección",
            status: estatusCanon,
          },
        };

        setMarkers([marker]);
        setEmpresaMarker(marker);
      } catch (error) {
        console.error("Error al obtener los instaladores:", error);
      }
    };
    if (empresaSeleccionada) {
      fetchInstaladores();
    } else {
      setInstaladores([]);
      setMarkers([]);
      setEmpresaMarker(null);
    }
  }, [empresaSeleccionada]);

  const columns = [
    {
      accessorKey: "progresoMultimedia",
      header: "Documentos disponibles",
      size: 80,
      Cell: ({ row }) => {
        const progreso = row.original.progresoMultimedia || 0;

        const color =
          progreso <= 50 ? "red" : progreso < 100 ? "orange" : "green";

        return (
          <div
            style={{
              width: 40,
              height: 18,
              border: `2px solid ${color}`,
              borderRadius: 14,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 10,
              color: "#000",
            }}
          >
            <span style={{ paddingTop: 1 }}>{parseInt(progreso)}%</span>
          </div>
        );
      },
    },
    { accessorKey: "nombre", header: "Nombre", size: 80 },
    { accessorKey: "apellidos", header: "Apellido", size: 80 },
    { accessorKey: "email", header: "Email", size: 80 },
    { accessorKey: "numGafete", header: "Número de credencial", size: 80 },
    { accessorKey: "telefono", header: "Teléfono", size: 80 },
    { accessorKey: "comentarios", header: "Comentarios", size: 80 },
  ];

  const table = useMaterialReactTable({
    autoResetPageIndex: false,
    columns,
    data: instaladores,
    enableSorting: false,
    enableFilters: false,
    enableRowSelection: true,
    enableTopToolbar: false,
    enableColumnActions: false,
    getRowId: (originalRow) => originalRow.id,
    positionToolbarAlertBanner: "none",
    localization: MRT_Localization_ES,
    layoutMode: "grid",
    defaultColumn: {
      minSize: 40,
      size: 80,
    },
    enablePagination: true,
    enableMultiRowSelection: false,
    muiTableBodyRowProps: ({ row, staticRowIndex, table }) => ({
      onClick: (event) =>
        getMRT_RowSelectionHandler({ row, staticRowIndex, table })(event),
      sx: { cursor: "pointer" },
    }),
    onRowSelectionChange: (rowSelection) => {
      setSelectedInstalador(rowSelection);
    },
    state: {
      rowSelection: selectedInstalador || {},
    },
    initialState: {
      pagination: { pageIndex: 0, pageSize: 5 },
    },
  });

  const handleComplete = async () => {
    if (
      selectedInstalador &&
      Object.keys(selectedInstalador).length > 0 &&
      empresaSeleccionada &&
      selected.length > 0
    ) {
      const contactoInstaladorId = Number(Object.keys(selectedInstalador)[0]);
      const instalador = instaladores.find(
        (instalador) => instalador.id === contactoInstaladorId
      );

      if (instalador?.progresoMultimedia < 50) {
        setOpenRazonModal(true);
      } else {
        const data = {
          fases: selected,
          trabajoId: trabajo.id,
          porEmpresa: false,
          distancia: distance,
          empresaId: null,
          razon: "",
          contactoInstaladorId,
        };

        setShowLoader(true);
        try {
          await createAsignacion(API_URL, data);
          setShowLoader(false);
          onConfirm();
          cleanAndClose();
        } catch (error) {
          setShowLoader(false);
          setShowSnackbar(true);
          setSnackbarMessage("Ocurrió un error al crear la asignación.");
        }
      }
    } else {
      setShowSnackbar(true);
      setSnackbarMessage(
        "Seleccione una fase de trabajo, una empresa y un instalador."
      );
    }
  };

  const handleCompleteWithRazon = async (razon) => {
    if (
      selectedInstalador &&
      Object.keys(selectedInstalador).length > 0 &&
      empresaSeleccionada &&
      selected.length > 0
    ) {
      const contactoInstaladorId = Number(Object.keys(selectedInstalador)[0]);

      const data = {
        fases: selected,
        trabajoId: trabajo.id,
        porEmpresa: false,
        distancia: distance,
        empresaId: null,
        razon,
        contactoInstaladorId,
      };

      setShowLoader(true);
      const res = await createAsignacion(API_URL, data);
      setShowLoader(false);
      if (!res[0].exitoso) {
        setShowSnackbar(true);
        setSnackbarMessage(res[0].mensaje);
      } else {
        onConfirm();
        cleanAndClose();
      }
    } else {
      setShowSnackbar(true);
      setSnackbarMessage(
        "Seleccione una fase de trabajo, una empresa y un instalador."
      );
    }
  };

  const cleanAndClose = () => {
    setSelected([]);
    setSelectedInstalador(null);
    setEmpresaMarker(null);
    setEmpresaSeleccionada(null);
    setMarkers([]);
    setInstaladores([]);
    handleCloseModal();
  };

  return (
    <>
      <Dialog
        fullWidth={true}
        maxWidth={"lg"}
        onClose={cleanAndClose}
        open={showModal}
        disableEnforceFocus
      >
        <Snackbar
          open={showSnackbar}
          autoHideDuration={3000}
          onClose={() => {
            setShowSnackbar(false);
            setSnackbarMessage("");
          }}
          message={snackbarMessage}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          slotProps={{
            content: {
              sx: {
                backgroundColor: "white",
                color: "#222",
                justifyContent: "center",
                textAlign: "center",
                fontWeight: "bold",
                fontSize: "16px",
                fontFamily: "Roboto, Arial, sans-serif",
              },
            },
          }}
        />
        <DialogContent>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "20px",
              height: "80vh",
              padding: "20px",
            }}
          >
            <Box
              sx={{
                gap: "20px",
              }}
              display="flex"
              alignItems="center"
            >
              <Typography sx={{ fontSize: "18px" }} align="left">
                Asignación de trabajo por instalador - {trabajo?.nombre}
              </Typography>

              <IconButton
                aria-label="close"
                onClick={cleanAndClose}
                sx={(theme) => ({
                  position: "absolute",
                  right: 6,
                  top: 6,
                  color: theme.palette.grey[500],
                })}
              >
                <CloseIcon />
              </IconButton>
            </Box>
            <div>Seleccionar fase de trabajo:</div>
            <FormGroup row>
              {fasesDeTrabajo.map((opt) => {
                return (
                  <FormControlLabel
                    key={opt.name}
                    control={
                      <Checkbox
                        checked={isSelected(opt.name)}
                        onChange={() => handleToggle(opt)}
                      />
                    }
                    label={
                      opt.descripcion !== "Entregable"
                        ? opt.descripcion
                        : "Implementación"
                    }
                  />
                );
              })}
            </FormGroup>
            <div>Seleccionar proveedor:</div>
            <SelectAutoComplete
              options={companies}
              placeholder="Proveedor"
              label="Proveedor"
              fieldC="razonSocial"
              width={"100%"}
              listHeight="200px"
              value={empresaSeleccionada}
              onChange={(e, value) => {
                setEmpresaSeleccionada(value);
              }}
            />
            <div>Seleccionar instalador:</div>
            <div style={{ width: "100%" }}>
              <MaterialReactTable table={table} />
            </div>

            <div
              className="mpp-mapWrap"
              style={{ padding: "0 0 40px 0", height: "500px" }}
            >
              <Map markers={markers} height="500px" />
            </div>
          </div>
        </DialogContent>

        <DialogActions>
          <CustomButton
            background="#FFFFFF"
            color="#000000"
            text="Cancelar"
            width="110px"
            height="36px"
            fontWeight="700"
            fontSize="14px"
            border="1px solid #D9D9D9"
            type="button"
            onClick={cleanAndClose}
          />
          <CustomButton
            text={"Guardar"}
            color={"#FFFFFF"}
            background={"#223D51"}
            fontStyle={"normal"}
            fontWeight={500}
            fontSize={"14px"}
            width={"110px"}
            height={"36px"}
            type={"button"}
            onClick={handleComplete}
          />
        </DialogActions>
      </Dialog>
      <RazonModal
        open={openRazonModal}
        onClose={() => {
          setOpenRazonModal(false);
          setRazon("");
        }}
        onConfirm={handleCompleteWithRazon}
      />
      <LoaderDialog open={showLoader} />
    </>
  );
};

export default ModalNuevaAsignacion;
